(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/filter-and-sort/assets/javascripts/components/filter-section.js') >= 0) return;  svs.modules.push('/components/casino-react/filter-and-sort/assets/javascripts/components/filter-section.js');

'use strict';

const _React = React,
  useMemo = _React.useMemo;
const useSearchParams = svs.components.casino_react.hooks.useSearchParams;
const FilterOption = svs.components.casino_react.filterAndSort.components.FilterOption;
const _svs$ui$ReactAccordio = svs.ui.ReactAccordion,
  AccordionItem = _svs$ui$ReactAccordio.AccordionItem,
  AccordionSummary = _svs$ui$ReactAccordio.AccordionSummary,
  AccordionDetails = _svs$ui$ReactAccordio.AccordionDetails;
const Badge = svs.ui.ReactBadge;
const FilterSection = _ref => {
  let filterSection = _ref.filterSection;
  const searchParams = useSearchParams();
  const activeSectionFilters = useMemo(() => searchParams[filterSection.type], [searchParams, filterSection.type]);
  return React.createElement(AccordionItem, {
    isFlat: true
  }, React.createElement(AccordionSummary, null, filterSection.title, activeSectionFilters.length > 0 && React.createElement(Badge, {
    bounce: true,
    className: "casino-filter-and-sort__filter-section-badge badge-casino",
    size: "small"
  }, activeSectionFilters.length)), React.createElement(AccordionDetails, null, React.createElement("ul", {
    className: "filter-list"
  }, filterSection.options.map(filterOption => React.createElement(FilterOption, {
    checked: activeSectionFilters.includes(filterOption.title),
    filterOption: filterOption,
    filterType: filterSection.type,
    key: filterOption.title
  })))));
};
setGlobal('svs.components.casino_react.filterAndSort.components.FilterSection', FilterSection);

 })(window);